import { createContext, useContext, type ReactNode } from "react";

import { useCompanyId } from "@/context/CompanyContext";

const CaseTenantContext = createContext<string | null>(null);

/** Scope case-detail UI to the opened case's tenant (Ani staff can open any tenant's case). */
export function CaseTenantProvider({ tenantId, children }: { tenantId?: string | null; children: ReactNode }) {
  return <CaseTenantContext.Provider value={tenantId ?? null}>{children}</CaseTenantContext.Provider>;
}

/** Opened case's tenant, falling back to the viewer's company outside a case. */
export function useCaseCheckingTenantId(): string | undefined {
  const caseTenantId = useContext(CaseTenantContext);
  const viewerCompanyId = useCompanyId();
  return caseTenantId ?? viewerCompanyId;
}
